'use strict'

import $ from 'jquery'

export function intro() {
	$('#btn_show_info_intro').on('click', function() {
		let lang = null
		Swal.fire({
			title: '',
			customClass: 'swal-intro swal-h-intro',
			html:
				'<p class="title-swal">Chọn ngôn ngữ</p>' +
				'<div class="flex-modal">' +
				'<div><button class="btn-lang btn-swal-intro" data-value="vi"><img class="img-vi  img-hover" src="/images/common/vi.png" width="80%" alt="vi"></button><p class="font-weight-600 d-xs-none">Vietnamese</p></div>' +
				'<div><button class="btn-lang btn-swal-intro" data-value="ja"><img class="img-jp  img-hover" src="/images/common/jp.png" width="80%" alt="ja"></button><p class="font-weight-600 d-xs-none">Japanese</p></div>' +
				'<div><button class="btn-lang btn-swal-intro" data-value="en"><img class="img-en  img-hover" src="/images/common/en.png" width="80%" alt="en"></button><p class="font-weight-600 d-xs-none">English</p></div>' +
				'</div>',

			showCloseButton: true,
			showCancelButton: false,
			showConfirmButton: false,
		}).then(
			$('.btn-lang').on('click', function() {
				lang = $(this).data('value')
				let adminText = 'Company Function'
				let userText = 'Individual Function'
				let selectUser = 'Select user'
				if (lang === 'vi') {
					adminText = 'Tính năng Công ty'
					userText = 'Tính năng Cá nhân'
					selectUser = 'Chọn người dùng'
				}
				if (lang === 'jp' || lang === 'ja') {
					adminText = '会社の機能'
					userText = '個別機能'
					selectUser = 'ユーザーを選択'
				}

				let userHtml = '<p class="font-weight-600 text-alg-user">' + userText + '</p>'
				let adminHtml = '<p class="font-weight-600 text-alg-admin">' + adminText + '</p>'
				let adminBtn = '<div class="box-img"><button class="btn-admin btn-actor" data-value="admin"><img class="img-warning" src="/images/common/admin.jpg" width=70%></button>' + adminHtml + '</div>'
				let userBtn = '<div class="box-img"><button class="btn-user btn-actor" data-value="user"><img class="img-success" src="/images/common/user.jpg" width=70%></button>' + userHtml + '</div>'
				Swal.fire({
					title: '',
					customClass: 'swal-intro swal-h-intro',
					html:
						'<p class="title-swal d-xs-none">' + selectUser + '</p>' +
						'<div class="flex-container ">' +
						adminBtn +
						userBtn +
						'</div>',

					showCloseButton: true,
					showCancelButton: false,
					showConfirmButton: false,
				}).then(
					$('.btn-actor').on('click', function() {
						let actor = $(this).data('value')
						let group = 1
						if (actor === 'user') {
							group = 4
						} else if (actor === 'admin') {
							group = 2
						}
						$.ajax({
							type: 'GET',
							url: '/books/cache-group',
							data: {
								'group': group,
								'lang': lang,
								'is_index': true,
							},
						}).done(function(response) {
							window.location.href = response.url || '/books/terra'
						}).fail(function(response) {
						})
					}),
				)
			}),
		)
	})
}
